// QL-414 — the settings of the two compliance chart PDF blocks (volatility
// chart, equity share chart): title, description, the time range printed and
// whether the chart and the data table print. The summary line and the
// advisor's decision print whatever the two switches are set to.

export const T = {
  en_GB: {
    title: "Title (optional)",
    titlePlaceholder: "Enter title...",
    titleHelp: "Optional heading to display above the content",
    description: "Description (optional)",
    descriptionPlaceholder: "Enter description...",
    descriptionHelp: "Optional text to display between the title and content",
    showChart: "Show chart",
    showChartHelp: "Print the chart.",
    showTable: "Show table",
    volatilityTableHelp: "Print the volatility table under the chart.",
    equityShareTableHelp: "Print the equity / non-equity table under the chart.",
    validationError: "At least one display option must be selected",
    validationErrorLong: "At least one display option (Chart or Table) must be selected",
  },
  nb_NO: {
    title: "Tittel (valgfri)",
    titlePlaceholder: "Skriv inn tittel...",
    titleHelp: "Valgfri overskrift som vises over innholdet",
    description: "Beskrivelse (valgfri)",
    descriptionPlaceholder: "Skriv inn beskrivelse...",
    descriptionHelp: "Valgfri tekst som vises mellom tittelen og innholdet",
    showChart: "Vis diagram",
    showChartHelp: "Skriv ut diagrammet.",
    showTable: "Vis tabell",
    volatilityTableHelp: "Skriv ut volatilitetstabellen under diagrammet.",
    equityShareTableHelp: "Skriv ut tabellen med aksjer / ikke-aksjer under diagrammet.",
    validationError: "Minst ett visningsalternativ må være valgt",
    validationErrorLong: "Minst ett visningsalternativ (diagram eller tabell) må være valgt",
  },
} as const;
